import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Placeholder } from 'semantic-ui-react';
import { noop } from 'lodash';
import classnames from 'classnames/bind';
import { GRAPH_API_FRAGMENT_DEFINITION, GRAPH_API_FRAGMENT_REFERENCE, } from '../../../utils/symbols';
import { AddressInfoLine, CardImage, ListingCardIndicator, } from '../../listing/listingCard/cardParts';
import SaleInfo from '../saleInfo';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const renderPlaceholder = () => (_jsx("div", { className: cx('property-value-container'), children: _jsxs(Placeholder, { className: cx('placeholder-main'), children: [_jsx(Placeholder.Header, { children: _jsx(Placeholder.Line, { length: 'short' }) }), _jsxs(Placeholder.Paragraph, { style: { width: '100%' }, children: [_jsx(Placeholder.Line, {}), _jsx(Placeholder.Line, {}), _jsx(Placeholder.Line, {}), _jsx(Placeholder.Line, {})] })] }) }));
const ClosingCard = ({ className = '', elmId = 'listing_card', closingMethod, loading = false, disabled = false, slots, featureFlags, }) => {
    const listing = closingMethod.listing;
    let soldOn = null;
    if (closingMethod.__typename === 'TrusteeContract') {
        soldOn = closingMethod.created_date;
    }
    else if (closingMethod.__typename === 'ReoOffer') {
        soldOn = closingMethod.sold_time;
    }
    return (_jsxs("div", { className: cx('root', { 'root-card-disabled': disabled }, className), children: [_jsxs("div", { className: cx('base-card', className), "data-elm-id": `property_card_${elmId}`, children: [_jsx(CardImage, { listing: listing, elmId: elmId, showSave: false, showImageCount: false, onSaveToggle: noop, featureFlags: featureFlags, loading: loading, maxBadges: 0, disabled: disabled, className: cx('card-image') }), _jsxs("div", { className: cx('property-card-body'), children: [_jsx("div", { className: cx('card-cta', 'desktop'), children: slots?.action?.() }), loading ? (renderPlaceholder()) : (_jsxs(_Fragment, { children: [_jsx(SaleInfo, { listingStatusGroup: listing.listing_status_group, soldAmount: closingMethod.winning_bid_amount, soldOn: soldOn, elmId: `${elmId}_sold_value` }), _jsx(AddressInfoLine, { address: listing.formatted_address || undefined, elmId: `${elmId}_address`, isCancelled: disabled, className: 'u-mb-1' }), _jsx(ListingCardIndicator, { listing: listing, elmId: `${elmId}_listing_indicator`, className: cx('asset-info') })] })), _jsx("div", { className: cx('card-cta'), children: slots?.action?.() })] })] }), _jsx("div", { children: slots?.details?.() })] }));
};
const LISTING_FRAGMENT = `
fragment ContractListing on Listing {
  listing_id
  listing_status
  listing_status_label(intent: SEARCH)
  listing_status_group
  auction {
    is_online
  }
  primary_property {
    property_id
  }
  listing_page_path
  primary_photo
  listing_configuration {
    asset_type
    product_type
    is_third_party_online
  }
  formatted_address(format: DOUBLE_LINE)
  venue {
    venue_type
  }
  event {
    trustee_sale
  }
}
`;
const REO_OFFER_FRAGMENT = `
  fragment ReoOfferDetails on ReoOffer {
    offer_id
    sold_time
    __typename
    winning_bid_amount
    listing {
      ...ContractListing
    }
  }
`;
const TRUSTEE_CONTRACT_FRAGMENT = `
  fragment TrusteeContractDetails on TrusteeContract {
    trustee_contract_id
    created_date
    __typename
    winning_bid_amount
    listing {
      ...ContractListing
    }
  }
`;
ClosingCard.ContractListingFragment = {
    [GRAPH_API_FRAGMENT_DEFINITION]: LISTING_FRAGMENT,
    [GRAPH_API_FRAGMENT_REFERENCE]: `...ContractListing`,
};
ClosingCard.TrusteeContractFragment = {
    [GRAPH_API_FRAGMENT_DEFINITION]: TRUSTEE_CONTRACT_FRAGMENT,
    [GRAPH_API_FRAGMENT_REFERENCE]: `...TrusteeContractDetails`,
};
ClosingCard.ReoOfferFragment = {
    [GRAPH_API_FRAGMENT_DEFINITION]: REO_OFFER_FRAGMENT,
    [GRAPH_API_FRAGMENT_REFERENCE]: `...ReoOfferDetails`,
};
export default ClosingCard;
//# sourceMappingURL=index.js.map